export default __webpack_public_path__ + "static/media/cvod-18.410f8c04.svg";